import { cn } from "@/lib/utils";

// The one small pill-toggle used across every feed's chip row (ActivityFeed categories/time
// window, FindingsList status toggle, EntityKindFilter) — extracted so the pattern lives in one
// place instead of being redrawn per surface.
export function Chip({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "rounded-full px-2.5 py-1 text-[10.5px] font-medium transition-colors",
        active
          ? "bg-primary/10 text-primary"
          : "text-muted-foreground hover:text-foreground",
      )}
    >
      {label}
    </button>
  );
}
